import React from "react";
import styled from "styled-components";
import { NotificationCriticalIcon } from "./icons/notification_critical";
import { CloseIcon } from "./icons/close";

const Container = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  flex: 1 1 0px;
  top: 0px;
  right: 0px;
  left: 0px;
  background-color: #FFD100;
  color: #0F0F0F;
  z-index: 1;
  box-sizing: border-box;
`;

const WarnningAndTextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const NotificationText = styled.span`
  font-size: 16px;
  font-weight: 400;
  margin: 0px 10px;
`;

const WarningIconWrapper = styled.div`
  width: 38px;
  height: 38px;
  min-width: 38px;
  min-height: 38px;
  max-width: 38px;
  max-height: 38px;
`;

const CloseIconWrapper = styled.div`
  cursor: pointer;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  max-width: 40px;
  max-height: 40px;
`;

class ModalNotification extends React.Component {

  showNotification = (event) => {
    this.updateStateIfMounted({isOpen: true, notificationMessage: event.detail?.message});
    setTimeout(() => {
      this.updateStateIfMounted({isOpen: false});
    }, event.detail?.time || 3000);
  }

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      notificationMessage: null
    }

    document.addEventListener('iac-options-modal-show-notification', this.showNotification);
    this._isMounted = true;
  }

  updateStateIfMounted = (newState) => {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('iac-options-modal-show-notification', this.showNotification);
    this._isMounted = false;
  }

  render = () => {
    return (
      <>
        {this.state.isOpen && <Container>
          <WarnningAndTextWrapper>
            <WarningIconWrapper>{NotificationCriticalIcon}</WarningIconWrapper>
            <NotificationText>{this.state.notificationMessage}</NotificationText>
          </WarnningAndTextWrapper>
          <CloseIconWrapper onClick={() => { this.updateStateIfMounted({isOpen: false}); }}>{CloseIcon}</CloseIconWrapper>
        </Container>}
      </>
    );
  };
}

export default ModalNotification;
